/** @jsxImportSource @emotion/react */
import { memo } from "react";
import { css } from "@emotion/react";

/**
 * footerコンポーネント
 */
const Footer = memo(() => {
  return (
    <div css={footerWrap}>
      <div css={footerContent}>
        {/* <div css={footerContentLinks}> */}
        <div>
          <ul css={footerList}>
            {/* <ul> */}
            <li>
              <a
                href="https://www.tokyo-gas.co.jp/utility/sitemap.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                サイトマップ
              </a>
            </li>
            <li>
              <a
                href="https://www.tokyo-gas.co.jp/utility/privacy.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                プライバシーポリシー
              </a>
            </li>
            <li>
              <a
                href="https://www.tokyo-gas.co.jp/utility/attention.html"
                target="_blank"
                rel="noopener noreferrer"
              >
                サイトのご利用について
              </a>
            </li>
          </ul>
        </div>
        <div css={footerContentCopyright}>
          <small>Copyright© TOKYO GAS Co., Ltd. All Rights Reserved.</small>
        </div>
      </div>
    </div>
  );
});

const footerWrap = css`
  color: var(--mtg-grey-1);
  width: 100%;
  padding: 32px 24px 24px;
  background-color: var(--mtg-white);
  @media screen and (max-width: 360px) {
    padding-bottom: 36px;
  }
`;

const footerContent = css`
  max-width: var(--mtg-max-width);
  margin: 0 auto;
`;

const footerList = css`
  display: flex;
  flex-wrap: wrap;
  li {
    font-size: var(--mtg-caption-s);
    font-weight: var(--mtg-caption-w);
    list-style: none;
    a {
      text-decoration: none;
      color: var(--mtg-grey-1);
      line-height: 18.84px;
    }
    a:hover {
      text-decoration: underline;
    }
    @media screen and (max-width: 600px) {
      width: 100%;
    }
  }
  li:not(:first-of-type) {
    margin-left: 40px;
    @media screen and (max-width: 600px) {
      margin-left: 0;
      margin-top: 16px;
    }
  }
`;

const footerContentCopyright = css`
  font-size: 10px;
  margin-top: 40px;
`;

export default Footer;
